// extracted by mini-css-extract-plugin
export default {"EditQuiz":"EditQuiz_EditQuiz__ItIwC"};